var _path, _path2, _path3, _path4, _path5, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtlasLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 29,
    viewBox: "0 0 34 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M11.7221 16.505C11.7221 13.3166 14.3068 10.7318 17.4953 10.7318C20.6837 10.7318 23.2685 13.3166 23.2685 16.505C23.2685 19.0859 25.3611 21.1786 27.942 21.1786C30.5229 21.1786 32.6155 19.0859 32.6155 16.505C32.6155 8.15425 25.8461 1.38477 17.4953 1.38477C9.14448 1.38477 2.375 8.15425 2.375 16.505",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M18.8926 21.7295C20.6988 24.8514 24.0747 26.9523 27.9411 26.9523",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M17.4956 16.5053C17.4956 19.3903 15.1571 21.7287 12.2722 21.7287C9.38725 21.7287 7.04883 19.3903 7.04883 16.5053C7.04883 10.736 11.7262 6.05859 17.4956 6.05859C23.2649 6.05859 27.9423 10.736 27.9423 16.5053",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3735 18.9999C3.37369 18.9999 4.18451 18.1891 4.18451 17.1889C4.18451 16.1887 3.37369 15.3779 2.3735 15.3779C1.37331 15.3779 0.5625 16.1887 0.5625 17.1889C0.5625 18.1891 1.37331 18.9999 2.3735 18.9999Z",
    fill: "#07CC9E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6721 26.7896C30.8254 26.888 30.8254 27.1121 30.6721 27.2105L28.0101 28.9182C27.8437 29.0249 27.6251 28.9054 27.6251 28.7077V25.2924C27.6251 25.0947 27.8437 24.9752 28.0101 25.082L30.6721 26.7896Z",
    fill: "#FF9C2B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.8477,
    y: 14.9883,
    width: 2.85,
    height: 2.85,
    rx: 0.25,
    transform: "rotate(40.7329 27.8477 14.9883)",
    fill: "#C30B31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlasLogo);
export default __webpack_public_path__ + "static/media/atlas-logo.56c2f60a0a3e56896b7466888f903f06.svg";
export { ForwardRef as ReactComponent };